export default "__VITE_ASSET__CDCjpA4L__"